import React, { useEffect, useState } from "react";

export default function LeaveOverview() {
  const [loading, setLoading] = useState(true);

  const [leaveData] = useState({
    onLeave: 19,
    pendingApproval: 8,
    approvedToday: 14,
    rejected: 3,
    absent: 12,
    lateCheckin: 21,
    attendance: 92,
    avgWorkingHours: "8.4h",
    fieldActive: 184,
    totalEmployees: 236,
  });

  const [claimData] = useState({
    submitted: 82,
    approved: 64,
    pending: 14,
    rejected: 4,
    claimAmount: 2.8,
    avgSettlement: "3.2 Days",
    approvalRate: 78,
    processingToday: 12,
    highPriority: 5,
    monthlyBudget: 4.5,
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1800);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <LeaveClaimSkeleton />;
  }

  return (
    <>
      {/* SHIMMER */}

      <style>
        {`
          @keyframes shimmer {
            0% {
              background-position: -400px 0;
            }

            100% {
              background-position: 400px 0;
            }
          }

          @keyframes pulse {
            0% {
              opacity: 0.75;
            }

            50% {
              opacity: 1;
            }

            100% {
              opacity: 0.75;
            }
          }
        `}
      </style>

      {/* -------------------------------------------------------------------------- */}
      {/* LEAVE OVERVIEW */}
      {/* -------------------------------------------------------------------------- */}

      <SectionHeader icon="🏖️" title="Leave Overview" />

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "58% 42%",
          gap: 14,
          marginBottom: 32,
        }}
      >
        {/* LEFT */}

        <div>
          {/* HERO */}

          {/* KPI */}

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3,minmax(0,1fr))",
              gap: 10,
              alignItems: "stretch",
            }}
          >
            {/* 6 MONTH LEAVE TREND */}

            <div
              style={{
                gridColumn: "span 3",
                background: "#fff",
                border: "1px solid #E2E8F0",
                borderRadius: 18,
                padding: 20,
                boxShadow: "0 2px 10px rgba(15,23,42,0.03)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <div>
                  <div
                    style={{
                      fontSize: 13,
                      fontWeight: 700,
                      color: "#334155",
                      textTransform: "uppercase",
                      letterSpacing: "0.06em",
                    }}
                  >
                    Last 6 Months Leave Trend
                  </div>

                  <div
                    style={{
                      fontSize: 11,
                      color: "#94A3B8",
                      marginTop: 4,
                    }}
                  >
                    Monthly leave analysis of sales employees
                  </div>
                </div>

                <div
                  style={{
                    background: "#ECFDF5",
                    color: "#059669",
                    padding: "6px 12px",
                    borderRadius: 999,
                    fontSize: 12,
                    fontWeight: 700,
                  }}
                >
                  ↓ 12% Reduced Leaves
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "space-between",
                  height: 220,
                  gap: 14,
                  paddingTop: 10,
                }}
              >
                {[
                  { month: "Jan", value: 78, color: "#3B82F6" },
                  { month: "Feb", value: 92, color: "#6366F1" },
                  { month: "Mar", value: 66, color: "#10B981" },
                  { month: "Apr", value: 110, color: "#F59E0B" },
                  { month: "May", value: 74, color: "#8B5CF6" },
                  { month: "Jun", value: 58, color: "#06B6D4" },
                ].map((item, index) => (
                  <div
                    key={index}
                    style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      height: "100%",
                    }}
                  >
                    <div
                      style={{
                        fontSize: 12,
                        fontWeight: 700,
                        color: item.color,
                        marginBottom: 8,
                      }}
                    >
                      {item.value}
                    </div>

                    <div
                      style={{
                        width: "100%",
                        height: `${item.value * 1.5}px`,
                        background: `linear-gradient(180deg, ${item.color}, ${item.color}CC)`,
                        borderRadius: "14px 14px 6px 6px",
                        boxShadow: `0 8px 18px ${item.color}33`,
                        transition: "0.3s",
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          inset: 0,
                          background:
                            "linear-gradient(to top, rgba(255,255,255,0.05), rgba(255,255,255,0.35))",
                        }}
                      />
                    </div>

                    <div
                      style={{
                        marginTop: 10,
                        fontSize: 12,
                        fontWeight: 600,
                        color: "#64748B",
                      }}
                    >
                      {item.month}
                    </div>
                  </div>
                ))}
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: 22,
                  borderTop: "1px solid #E2E8F0",
                  paddingTop: 16,
                }}
              >
                <div>
                  <div
                    style={{
                      fontSize: 11,
                      color: "#94A3B8",
                      marginBottom: 4,
                    }}
                  >
                    Highest Leave
                  </div>

                  <div
                    style={{
                      fontSize: 16,
                      fontWeight: 700,
                      color: "#F59E0B",
                    }}
                  >
                    April • 110
                  </div>
                </div>

                <div>
                  <div
                    style={{
                      fontSize: 11,
                      color: "#94A3B8",
                      marginBottom: 4,
                    }}
                  >
                    Lowest Leave
                  </div>

                  <div
                    style={{
                      fontSize: 16,
                      fontWeight: 700,
                      color: "#06B6D4",
                    }}
                  >
                    June • 58
                  </div>
                </div>

                <div>
                  <div
                    style={{
                      fontSize: 11,
                      color: "#94A3B8",
                      marginBottom: 4,
                    }}
                  >
                    Avg Monthly
                  </div>

                  <div
                    style={{
                      fontSize: 16,
                      fontWeight: 700,
                      color: "#334155",
                    }}
                  >
                    79 Leaves
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT GRAPH */}

        <GraphContainer title="Leave Distribution">
          <ProgressGroup
            items={[
              {
                label: "Casual Leave",
                value: 72,
                color: "#3B82F6",
              },
              {
                label: "Sick Leave",
                value: 48,
                color: "#10B981",
              },
              {
                label: "Paid Leave",
                value: 84,
                color: "#8B5CF6",
              },
              {
                label: "Unplanned",
                value: 26,
                color: "#EF4444",
              },
            ]}
          />
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: 10,
              marginTop: 22,
            }}
          >
            <StatCard
              label="Pending Approval"
              value={leaveData.pendingApproval}
              accent="amber"
              icon="⌛"
            />

            <StatCard
              label="Approved Today"
              value={leaveData.approvedToday}
              accent="green"
              icon="✅"
            />

            <StatCard
              label="Rejected"
              value={leaveData.rejected}
              accent="red"
              icon="❌"
            />
          </div>
        </GraphContainer>
      </div>

      {/* -------------------------------------------------------------------------- */}
      {/* CLAIM OVERVIEW */}
      {/* -------------------------------------------------------------------------- */}

      <SectionHeader icon="🧾" title="Claim Overview" />

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "58% 42%",
          gap: 14,
        }}
      >
        {/* LEFT */}

        <div>
          {/* HERO */}

          {/* KPI */}

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3,1fr)",
              gap: 12,
            }}
          >
            <StatCard
              label="Claims Submitted"
              value={claimData.submitted}
              accent="blue"
              icon="📨"
            />

            <StatCard
              label="Processing Today"
              value={claimData.processingToday}
              accent="amber"
              icon="⚡"
            />

            <StatCard
              label="High Priority"
              value={claimData.highPriority}
              accent="red"
              icon="🚨"
            />

            <StatCard
              label="Avg Settlement"
              value={claimData.avgSettlement}
              accent="green"
              icon="✅"
            />

            <StatCard
              label="Approval Rate"
              value={`${claimData.approvalRate}%`}
              accent="blue"
              icon="📈"
            />

            <StatCard
              label="Monthly Budget"
              value={`₹${claimData.monthlyBudget}L`}
              accent="green"
              icon="💰"
            />
          </div>
        </div>

        {/* RIGHT GRAPH */}

        <GraphContainer title="Claim Status Analysis">
          <ProgressGroup
            items={[
              {
                label: "Approved",
                value: 78,
                color: "#10B981",
              },
              {
                label: "Pending",
                value: 22,
                color: "#F59E0B",
              },
              {
                label: "Rejected",
                value: 8,
                color: "#EF4444",
              },
              {
                label: "Priority",
                value: 14,
                color: "#8B5CF6",
              },
            ]}
          />

          <BottomMetrics
            items={[
              {
                label: "Settlement",
                value: "3.2d",
              },
              {
                label: "Claims",
                value: "82",
              },
              {
                label: "Approved",
                value: "78%",
              },
            ]}
          />
        </GraphContainer>
      </div>
    </>
  );
}

/* -------------------------------------------------------------------------- */
/* SECTION HEADER */
/* -------------------------------------------------------------------------- */

function SectionHeader({ icon, title }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        marginBottom: 14,
        marginTop: 24,
        paddingBottom: 10,
        borderBottom: "1px solid #E2E8F0",
      }}
    >
      <span style={{ fontSize: 18 }}>{icon}</span>

      <span
        style={{
          fontSize: 13,
          fontWeight: 700,
          letterSpacing: "0.08em",
          textTransform: "uppercase",
          color: "#334155",
        }}
      >
        {title}
      </span>
    </div>
  );
}

/* -------------------------------------------------------------------------- */
/* HERO MINI */
/* -------------------------------------------------------------------------- */

function HeroMini({ label, value }) {
  return (
    <div>
      <div
        style={{
          fontSize: 11,
          opacity: 0.8,
          marginBottom: 4,
        }}
      >
        {label}
      </div>

      <div
        style={{
          fontSize: 18,
          fontWeight: 700,
        }}
      >
        {value}
      </div>
    </div>
  );
}

/* -------------------------------------------------------------------------- */
/* TREND BADGE */
/* -------------------------------------------------------------------------- */

function TrendBadge({ value }) {
  return (
    <div
      style={{
        background: "rgba(255,255,255,0.14)",
        padding: "6px 12px",
        borderRadius: 999,
        fontSize: 13,
        fontWeight: 700,
        backdropFilter: "blur(10px)",
        animation: "pulse 2s infinite",
      }}
    >
      ↑ {value}% Growth
    </div>
  );
}

/* -------------------------------------------------------------------------- */
/* KPI CARD */
/* -------------------------------------------------------------------------- */
function StatCard({ label, value, accent, icon }) {
  const accents = {
    green: {
      text: "#059669",
      border: "#A7F3D0",
      bg: "#ECFDF5",
    },

    red: {
      text: "#DC2626",
      border: "#FECACA",
      bg: "#FEF2F2",
    },

    amber: {
      text: "#D97706",
      border: "#FDE68A",
      bg: "#FFFBEB",
    },

    blue: {
      text: "#2563EB",
      border: "#BFDBFE",
      bg: "#EFF6FF",
    },
  };

  const c = accents[accent];

  return (
    <div
      style={{
        background: "#fff",
        border: `1px solid ${c.border}`,
        borderRadius: 14,
        padding: "12px 14px",
        boxShadow: "0 1px 6px rgba(15,23,42,0.04)",
        minHeight: 84,

        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 10,
        }}
      >
        <span
          style={{
            fontSize: 10,
            fontWeight: 700,
            color: "#94A3B8",
            textTransform: "uppercase",
            letterSpacing: "0.05em",
            lineHeight: 1.3,
          }}
        >
          {label}
        </span>

        <div
          style={{
            width: 28,
            height: 28,
            borderRadius: 10,
            background: c.bg,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 14,
          }}
        >
          {icon}
        </div>
      </div>

      <div
        style={{
          fontSize: 24,
          fontWeight: 800,
          color: c.text,
          lineHeight: 1,
        }}
      >
        {value}
      </div>
    </div>
  );
}

/* -------------------------------------------------------------------------- */
/* GRAPH CONTAINER */
/* -------------------------------------------------------------------------- */

function GraphContainer({ title, children }) {
  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #E2E8F0",
        borderRadius: 18,
        padding: 18,
        boxShadow: "0 2px 10px rgba(15,23,42,0.03)",
      }}
    >
      <div
        style={{
          fontSize: 13,
          fontWeight: 700,
          color: "#334155",
          marginBottom: 22,
          textTransform: "uppercase",
        }}
      >
        {title}
      </div>

      {children}
    </div>
  );
}

/* -------------------------------------------------------------------------- */
/* PROGRESS GROUP */
/* -------------------------------------------------------------------------- */

function ProgressGroup({ items }) {
  return (
    <div>
      {items.map((item, index) => (
        <div
          key={index}
          style={{
            marginBottom: 20,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 6,
            }}
          >
            <span
              style={{
                fontSize: 12,
                fontWeight: 600,
                color: "#334155",
              }}
            >
              {item.label}
            </span>

            <span
              style={{
                fontSize: 12,
                fontWeight: 700,
                color: item.color,
              }}
            >
              {item.value}%
            </span>
          </div>

          <div
            style={{
              height: 8,
              background: "#E2E8F0",
              borderRadius: 999,
              overflow: "hidden",
            }}
          >
            <div
              style={{
                width: `${item.value}%`,
                height: "100%",
                background: item.color,
                borderRadius: 999,
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}

/* -------------------------------------------------------------------------- */
/* BOTTOM METRICS */
/* -------------------------------------------------------------------------- */

function BottomMetrics({ items }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        borderTop: "1px solid #E2E8F0",
        paddingTop: 16,
        marginTop: 20,
      }}
    >
      {items.map((item, index) => (
        <div key={index}>
          <div
            style={{
              fontSize: 11,
              color: "#94A3B8",
              marginBottom: 4,
            }}
          >
            {item.label}
          </div>

          <div
            style={{
              fontSize: 16,
              fontWeight: 700,
              color: "#334155",
            }}
          >
            {item.value}
          </div>
        </div>
      ))}
    </div>
  );
}

/* -------------------------------------------------------------------------- */
/* SKELETON */
/* -------------------------------------------------------------------------- */

function LeaveClaimSkeleton() {
  return (
    <div
      style={{
        height: 720,
        borderRadius: 18,
        background: "linear-gradient(90deg,#E2E8F0,#F8FAFC,#E2E8F0)",
        backgroundSize: "800px 100%",
        animation: "shimmer 1.5s infinite linear",
      }}
    />
  );
}
